import React from "react";
import Avatar from "../../../Avatar/Avatar";

const NewJoinerMemberList = ({ newjoiner }) => {
  //const dashMemberList = props.requestdata;
  return (
    <div className="py-2 px-4">
      <div className="flex justify-between items-center border-b border-b-gray-300 py-3">
        <div className="flex justify-between items-center gap-3">
          <Avatar image={newjoiner.photo} status="available" />
          <div>
            <p className="text-sm leading-5 font-medium text-gray-800">
              {newjoiner.name}
            </p>
            <p className="text-xs leading-4 font-normal text-gray-500">
              {newjoiner.designation_title} | {newjoiner.department_name}
            </p>
          </div>
        </div>
        <div className="flex gap-2 relative">
          {/* <i className="ico-right cursor-pointer"  /> */}

          <div className="flex gap-2 justify-center py-4"></div>
        </div>
      </div>
    </div>
  );
};

export default NewJoinerMemberList;
